import React, {
  SyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import Router from 'next/router'
import 'xgplayer'
import FlvPlayer from 'xgplayer-flv'
import XgLiveLogger from '@byted/xgplayer-live-logger'

export default (
  url: string,
  id: string,
  onPlay?: () => void,
  onEnded?: () => void,
  onError?: (err: any) => void
) => {
  const _player = new FlvPlayer({
    id,
    url: url.replace('http://', 'https://'),
    isLive: true,
    playsinline: true,
    fluid: true,
    autoplay: true,
    crossOrigin: true,
    autoplayMuted: true,
    closePlayVideoFocus: true,
    closeFocusVideoFocus: true,
    ignores: [
      'time',
      'definition',
      'error',
      'fullscreen',
      'i18n',
      'loading',
      'mobile',
      'play',
      'poster',
      'progress',
      'replay',
      'volume',
    ],
    controls: false,
    closeVideoClick: true,
  })
  _player.on('play', () => {
    onPlay && onPlay()
    console.log('play')
  })
  _player.on('error', (err: any) => {
    onError && onError(err)
    console.log(err, 'ffffff')
  })
  _player.on('ended', () => {
    onEnded && onEnded()
    console.log('ened')
  })

  try {
    const logger = new XgLiveLogger({
      player: _player, // xgplayer播放器实例（必传）
      aid: '1839', // 应用id（必传）请在https://appcloud.bytedance.net/上申请
      project_key: 'auto_web_pc', //项目名称（必传）
      app_name: 'auto_web_pc', // app名称（必传）
      ext: {
        home_live: 1,
      },
      onReport: (event_key: string, data: Record<string, any>) => {
        console.log(event_key)
      },
    })
  } catch (e) {
    //qq浏览器mac 报错
  }

  return _player
}
